import { useDispatch, useSelector } from "react-redux";

import { CreateExperience } from "../../redux/experience";
import { ErrorBanner } from "../../components/banner";
import { ExperienceForm } from "./ExpForm";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const ExperienceCreate = () => {
  const { loading, error } = useSelector((state) => state.experiences);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this experience?`)) {
      dispatch(CreateExperience(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about/experiences");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <ExperienceForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
